import PropTypes from 'prop-types'
import { detect } from 'detect-browser'
import classNames from 'classnames'

import OutdatedBrowser from 'components/OutdatedBrowser'
import Footer from 'components/Footer'

import s from './Layout.module.css'
import Header from '../Header'
import { useRouter } from 'next/router'

function Layout({
  children,
  footerLess = false,
  className = '',
  contentClassName = '',
}) {
  const browser = detect()
  const router = useRouter()

  const disableHeaderPaths = ['/', '/404']

  return (
    <>
      {!disableHeaderPaths.find(
        (p) =>
          (p.startsWith && router.pathname.startsWith(p.startsWith)) ||
          p === router.pathname
      ) && <Header />}
      <div className={className}>
        <OutdatedBrowser visible={browser && browser.name === 'ie'} />
        <main id="layout" className={classNames(s.main, contentClassName)}>
          {children}
        </main>
        {!footerLess && <Footer />}
      </div>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  footerLess: PropTypes.bool,
  contentClassName: PropTypes.string,
}

export default Layout
